module.exports = __webpack_public_path__ + "static/media/22.446b93ee.png";